var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 24,
    viewBox: "0 0 317 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83009 10.9998L10.7066 8.11531C11.0953 7.72552 11.0948 7.09456 10.7056 6.70531C10.316 6.31568 9.68423 6.31568 9.2946 6.70531L4.7072 11.2927C4.31668 11.6832 4.31668 12.3164 4.7072 12.7069L9.2946 17.2943C9.68423 17.684 10.316 17.684 10.7056 17.2943C11.0948 16.9051 11.0953 16.2741 10.7066 15.8843L7.83009 12.9998H19.0001C19.5524 12.9998 20.0001 12.5521 20.0001 11.9998C20.0001 11.4475 19.5524 10.9998 19.0001 10.9998H7.83009Z",
    fill: "#67737E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M309.17 13.0002L306.293 15.8847C305.905 16.2745 305.905 16.9054 306.294 17.2947C306.684 17.6843 307.316 17.6843 307.705 17.2947L312.293 12.7073C312.683 12.3168 312.683 11.6836 312.293 11.2931L307.705 6.70567C307.316 6.31604 306.684 6.31604 306.294 6.70567C305.905 7.09492 305.905 7.72588 306.293 8.11567L309.17 11.0002L298 11.0002C297.448 11.0002 297 11.4479 297 12.0002C297 12.5525 297.448 13.0002 298 13.0002L309.17 13.0002Z",
    fill: "#67737E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 289,
    height: 2,
    fill: "#67737E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.65b25e78956f1cc8cf2940cb406a7dbf.svg";
export { ForwardRef as ReactComponent };